export default __webpack_public_path__ + "static/ef-partner-logo-3d9386c0bfc6188da24006eb194fbf20.png";